import { render, staticRenderFns } from "./ViewLogin.vue?vue&type=template&id=09878560&"
import script from "./ViewLogin.vue?vue&type=script&lang=js&"
export * from "./ViewLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports